module.exports = __webpack_public_path__ + "img/icon-1.64b680e9.png";